import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '../ui/Button';

interface ActivityLogProps {
  value: string;
  draft: string;
  onDraftChange: (value: string) => void;
  onCommit: (value: string) => void;
}

export const ActivityLog: React.FC<ActivityLogProps> = ({ value, draft, onDraftChange, onCommit }) => {
  const commit = () => {
    if (draft.trim()) onCommit(draft.trim());
  };
  return (
    <section className="pt-6 mt-6 border-t border-white/10 group" onClick={event => event.stopPropagation()} data-testid="activity-log">
      <h3 className="type-heading mb-3 flex items-center gap-2 text-base text-brand-neonBlue"><MessageSquare size={16} /> Activity &amp; Notes Log</h3>
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <input
          type="text"
          placeholder="Log a call, email, or update..."
          value={draft}
          onChange={event => onDraftChange(event.target.value)}
          onKeyDown={event => { if (event.key === 'Enter') commit(); }}
          className="flex-1 min-h-11 bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-xs md:text-sm text-white focus:border-brand-neonBlue outline-none transition-colors placeholder:text-slate-600"
        />
        <Button onClick={event => { event.stopPropagation(); commit(); }} className="min-h-11 bg-brand-neonBlue text-slate-950 font-bold px-6 py-3 rounded-xl shadow-neon border-none w-full sm:w-auto">Log Update</Button>
      </div>
      <div className="bg-slate-950/40 rounded-xl p-4 md:max-h-60 md:overflow-y-auto custom-scrollbar">
        {value ? (
          <div className="text-xs md:text-sm text-slate-300 font-medium whitespace-pre-wrap leading-relaxed space-y-4">
            {value.split('\n\n').map((block, index) => {
              const lines = block.split('\n');
              return lines[0]?.startsWith('[') ? (
                <div key={index} className="border-b border-white/5 pb-3 last:border-0 last:pb-0"><span className="type-label mb-1 block text-brand-neonBlue">{lines[0]}</span><span className="block leading-snug text-slate-300">{lines.slice(1).join('\n')}</span></div>
              ) : <div key={index} className="border-b border-white/5 pb-3 last:border-0 last:pb-0">{block}</div>;
            })}
          </div>
        ) : <div className="py-6 text-center text-sm font-medium text-slate-500">No activity logged yet.</div>}
      </div>
    </section>
  );
};
